export const providerListToColumnMap = {
	// Should be ordered in the order that it should be displayed
	Mappedin: {
		Categories: {
			name: 'Name',
		},
		Stores: {
			title:          'Name',
			type:           'Text Small',
			description:    'Text Large',
			landmark_id:    'Location (apt/suite)',
			phone:          'Text Small',
			logo:           'Image',
			mall_store_url: 'Text Small',
			hours:          'Text Large',
		},
	},
	Placewise: {
		Categories: {
			name: 'Name',
		},
		Events: {
			title:       'Text Small',
			description: 'Text Large',
			date_text:   'Text Medium',
			short_text:  'Text Small',
			image:       'Image',
			location:    'Text Small',
		},
		Stores: {
			title:           'Name',
			description:     'Text Large',
			tenant_location: 'Text Small',
			landmark_id:     'Location (apt/suite)',
			phone:           'Text Small',
			logo:            'Image',
			image:           'Image',
			mall_store_url:  'Text Small',
			hours:           'Text Large',
		},
	},
	Pylot: {
		// Should be ordered in the order that it should be displayed
		Categories: {
			name:        'Name',
			description: 'Text Large',
		},
		Stores: {
			title:          'Name',
			store_logo:     'Image',
			phone:          'Text Small',
			description:    'Text Large',
			location:       'Text Small',
			landmark_id:    'Location (apt/suite)',
			mall_store_url: 'Text Small',
			hours:          'Text Large',
		},
		Events: {
			title:       'Name',
			excerpt:     'Text Large',
			content:     'Text Large',
			location:    'Text Small',
			landmark_id: 'Location (apt/suite)',
			event_image: 'Image',
			date:        'Text Medium',
			date_time:   'Text Small',
		},
	},
	MallMaverick: {
		// Should be ordered in the order that it should be displayed
		Categories: {
			name:        'Name',
			description: 'Text Large',
		},
		Stores: {
			title:          'Name',
			description:    'Text Large',
			location:       'Text Small',
			landmark_id:    'Location (apt/suite)',
			phone:          'Text Small',
			logo:           'Image',
			image:          'Image',
			mall_store_url: 'Text Small',
			hours:          'Text Large',
		},
		Events: {
			title:       'Text Small',
			description: 'Text Large',
			date_text:   'Text Medium',
			short_text:  'Text Small',
			image:       'Image',
			location:    'Text Small',
		},
	},
	USCourts: {
		// Should be ordered in the order that it should be displayed
		Courts: {
			FULLDATETIME:        'Text Small',
			FULLDATETIMEDISPLAY: 'Text Small',
			TIMEONLY:            'Text Small',
			CASELOCATION:        'Text Small',
			JUDGEFULLNAME:       'Text Small',
			CASENUMBER:          'Text Small',
			CASETITLE:           'Text Small',
			CASETYPE:            'Text Small',
			Map:                 'Image',
			FULLDATETIMEUNIX:    'Text Small',
		},
	},
	KingCounty: {
		// Should be ordered in the order that it should be displayed
		Courts: {
			DEFENDANTNAME: 'Text Small',
			COURTROOM:     'Text Small',
			TIME:          'Text Small',
			CASENUMBER:    'Text Small',
			BUILDING:      'Text Small',
			CASETYPE:      'Text Small',
		},
	},
};

// Debug function to handle unknown providers
const getProviderConfig = (provider) => {
	console.log(`Looking for provider config for: "${provider}"`);
	const config = providerListToModalContent[provider];
	if (!config) {
		console.error(`Unknown provider: "${provider}". Available providers:`, Object.keys(providerListToModalContent));
		// Return a default config to prevent crashes
		return {
			label:  `Unknown Provider (${provider})`,
			fields: {
				authCode: 'Auth Code',
			},
		};
	}
	console.log(`Found config for provider "${provider}":`, config);
	return config;
};

const _providerListToModalContent = {
	mappedin: {
		label:  'Mappedin',
		fields: {
			authCode: 'Secret Key',
			key:      'ID',
			mapID:    'Venue',
		},
	},
	placewise: {
		label:  'Placewise',
		fields: {
			authCode:        'API Key',
			loyaltyClubSlug: 'Loyalty Club Slug',
		},
	},
	uscourts: {
		label:  'US Courts',
		fields: {
			authCode: 'Court Feed URL',
		},
	},
	kingcounty: {
		label:  'KingCounty',
		fields: {
			authCode: 'Court Feed URL',
		},
	},
	pylot: {
		label:  'Pylot',
		fields: {
			authCode: 'Mall Website URL',
		},
	},
	mallmaverick: {
		label:  'MallMaverick',
		fields: {
			authCode:        'API Key',
			loyaltyClubSlug: 'Property ID',
		},
	},
};

// Create a proxy to catch and log all access attempts
export const providerListToModalContent = new Proxy(_providerListToModalContent, {
	get(target, prop) {
		console.log(`Accessing provider config for key: "${prop}"`);
		if (prop in target) {
			console.log(`Found provider config for: "${prop}"`);
			return target[prop];
		}

		console.error(`Provider not found: "${prop}". Available providers:`, Object.keys(target));
		// Return a default config to prevent crashes
		return {
			label:  `Unknown Provider (${prop})`,
			fields: {
				authCode: 'Auth Code',
			},
		};
	},
});

// Export the debug helper
export {
	getProviderConfig,
};